import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl, Validator, ValidationErrors } from '@angular/forms';
import { ValidationTypes } from './validator-const.model';
import { BaseValidator } from './base.directive';
import { TranslationService } from '../../common/services/translation.service';
// tslint:disable-next-line:max-line-length
const URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

@Directive({
    selector: `[cpqURL]`,
    providers: [{ provide: NG_VALIDATORS, useExisting: UrlDirective, multi: true }],
    standalone: false
})
export class UrlDirective extends BaseValidator implements Validator {

    constructor(private translationService: TranslationService) {
        super();
    }

    validate(c: FormControl<string>): ValidationErrors {
        let isValid = true;
        if (c.value) {
            isValid = URL_REGEX.test(c.value);
        }
        return isValid ? null : this.createMessage(ValidationTypes.cpqURL, this.translationService.translate('Admin.Validation.InvalidURL'));
    }
}
